import "/assets/styles/sections/home/solutions.scss";

// Partials
import Btn from '/views/partials/btn';

const Solutions = () => {
	return (
		<section
			id="solutions"
			className="section home-solutions">
			<div className="solutions-wrap wrapper">
				<h2 className="solutions-title">
					Start Transforming Your Event Experience Today.
				</h2>

				<p className="solutions-subtitle">
					Incy is trusted by event organizers worldwide. Get a tailored solution that fits your scale and ambition.
				</p>

				<Btn
					tag="a"
					href="#contact"
					className="solutions-cta secondary big">
					Schedule for a Free Consultation
				</Btn>
			</div>
		</section>
	);
};

export default Solutions;
